import { Pipe, PipeTransform } from '@angular/core';
import {
  NOTIFICATION_LOCATION_CONFIG,
  NotificationLocation,
  SystemNotification
} from '../models/system-notification-message';

@Pipe({ name: 'notificationLocation' })
export class NotificationLocationPipe implements PipeTransform {
  transform(value: SystemNotification): string {
    if (value != null) {
      return Object.keys(NOTIFICATION_LOCATION_CONFIG)
        .filter((key: NotificationLocation) => {
          if (key === NotificationLocation.LOGIN_PAGE) {
            return value.showAtLoginPage;
          } else if (key === NotificationLocation.NOTIFICATION_CENTER) {
            return value.showAtNotificationCenter;
          }

          return false;
        })
        .map((key: NotificationLocation) => {
          return NOTIFICATION_LOCATION_CONFIG[key].description;
        })
        .join(' & ');
    }

    return null;
  }
}
